import {getImageUrl} from '../../../common/state/apiGet';
import {parseLandingUriFromServer} from '../../../common/util/PageRouter';
import {IMainSecondTab} from '../../main/type';
import {IEventPopup, INoticePopup} from '../type';

export function getNoticePopup(
  notice: I_NoticePopup
): INoticePopup | undefined {
  return notice
    ? {
        id: notice.id + notice.lastModifiedDateTime,
        title: notice.title,
        date: notice.subTitle,
        content: notice.contents,
        buttonTitle: notice.buttonTitle,
        isMaintenance: !notice.showButtonFlag,
      }
    : undefined;
}

export function getEventPopup(
  eventPopupList: I_EventPopup[] = []
): IEventPopup[] {
  return eventPopupList.map(eventPopup => ({
    id: eventPopup.id,
    title: eventPopup.title,
    date: eventPopup.subTitle,
    popupImgUrl: getImageUrl(eventPopup.thumbnailImage, {hasAlpha: true}),
    landingUri: parseLandingUriFromServer(eventPopup.landingUrl),
    buttonTitle: eventPopup.buttonTitle,
  }));
}

interface I_NoticePopup {
  id: number;
  title: string;
  subTitle: string;
  buttonTitle: string;
  contents: string;
  showButtonFlag: boolean;
  lastModifiedDateTime: string;
}

interface I_EventPopup {
  id: number;
  title: string;
  subTitle: string;
  thumbnailImage: string;
  buttonTitle: string;
  landingUrl: string;
  lastModifiedDateTime: string;
}

interface I_TabInfoItem {
  module: string;
  tabs: Array<{
    placement: string;
    defaultSection: boolean;
  }>;
}

export function getInitialMainTab(data: I_TabInfoItem[] = []): IMainSecondTab {
  const main = data.find(item => item.module === 'MAIN');
  const special = main?.tabs.find(item => item.placement === 'main_special');
  const waitfree = main?.tabs.find(item => item.placement === 'main_gidamoo');
  return special?.defaultSection
    ? 'special'
    : waitfree?.defaultSection
      ? 'waitfree'
      : 'recommend';
}
